export default __webpack_public_path__ + "static/media/portfolio-linkedin.1ecee4a9.png";